export const EVENTS = {
  TRACKING: {
    BY_CODE: 'tracking.byCode',
    LOADED: 'tracking.loaded',
    ERROR: 'tracking.error',
    GENERATE_LINK: 'tracking.generateLink',
    LINK_GENERATED: 'tracking.linkGenerated',
    COPY_LINK: 'tracking.copyLink',
    LINK_COPIED: 'tracking.linkCopied',
    COPY_CODE: 'tracking.copyCode',
    CODE_COPIED: 'tracking.codeCopied',
  }
};

export const ENDPOINTS = {
  TRACKING: {
    BASE: 'https://api.monrapidoo.com',
    ORDER: 'https://api.monrapidoo.com/order/details/:code?group=ultraxeno',
    PACKAGE: 'https://api.monrapidoo.com/package/track/:code?group=ultraxeno',
  }
};

export const STATUS_LABELS = {
  pending: 'En attente',
  confirmed: 'Confirmé',
  preparing: 'En préparation',
  ready_for_pickup: 'Prêt à être récupéré',
  picked_up: 'Récupéré',
  in_transit: 'En cours de livraison',
  delivered: 'Livré',
  cancelled: 'Annulé',
  // Package statuses
  created: 'Créé',
  cooked: 'Prêt',
  deliveryStarted: 'En livraison',
};

export const STATUS_ICONS = {
  pending: 'clock',
  confirmed: 'check',
  preparing: 'utensils',
  ready_for_pickup: 'box',
  picked_up: 'truck',
  in_transit: 'truck',
  delivered: 'check-circle',
  cancelled: 'x-circle',
  // Package statuses
  created: 'clock',
  cooked: 'box',
  deliveryStarted: 'truck',
};
